import { autoinject, bindable, observable } from 'aurelia-framework';
import { I18N } from 'aurelia-i18n';
import { ValidationController, ValidationRules, Validator } from 'aurelia-validation';
import { AsyncErrorHandler } from 'lib/ui';
import { EnvironmentalConditionDto } from 'models/pen/EnvironmentalCondition';
import { GlobalAnalysisDto } from 'models/pen/GlobalAnalysis';
import { ErrorService } from 'services/error-service';

@autoinject
export class EnvironmentalConditionCreateEdit {
  @bindable
  @observable
  model: EnvironmentalConditionDto = new EnvironmentalConditionDto();
  modelChanged(model: EnvironmentalConditionDto) {
    if (!model) return;
    this.form = JSON.parse(JSON.stringify(model));
  }

  @bindable
  onSave: (data: { data: EnvironmentalConditionDto }) => void;

  @bindable
  onCanceled: () => void;

  @bindable
  visible = false;

  @bindable
  globalAnalyses: GlobalAnalysisDto[] = [];

  protected form: EnvironmentalConditionDto = new EnvironmentalConditionDto();

  constructor(
    private errorService: ErrorService,
    private validationController: ValidationController,
    private validator: Validator,
    private t: I18N
  ) {}

  protected applyValidationRules() {
    ValidationRules.ensure('GlobalAnalysisId')
      .required()
      .withMessage(this.t.tr('general.requiredField'))
      .on(this.form);
  }

  attached() {
    this.applyValidationRules();
  }

  private async validate() {
    this.applyValidationRules();
    await this.validator.validateObject(this.form);
    return (await this.validationController.validate({ object: this.form })).valid;
  }

  @AsyncErrorHandler
  async save() {
    const valid = await this.validate();
    if (!valid) return;
    this.onSave({ data: this.form });
  }

  cancel() {
    this.onCanceled?.();
  }
}
